module.exports = __webpack_public_path__ + "img/smart-01.3d057e58.jpg";